import { render, staticRenderFns } from "./DAddressEditor.vue?vue&type=template&id=4c3c10b6&"
import script from "./DAddressEditor.vue?vue&type=script&lang=js&"
export * from "./DAddressEditor.vue?vue&type=script&lang=js&"
import style0 from "./DAddressEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports